<template>
  <li>
    <RouterLink
      :to="{
        name: 'admin.pipelines.pipelineId',
        params: {
          pipelineId: pipeline.id,
        },
      }"
      class="block hover:bg-gray-50"
    >
      <div class="flex items-center px-4 py-4 sm:px-6">
        <div class="min-w-0 flex-1 flex items-center">
          <div class="min-w-0 flex-1 pr-4 md:grid md:grid-cols-2 md:gap-4">
            <div>
              <p class="text-sm font-medium text-indigo-600 truncate">
                {{ pipeline.name }}
              </p>
              <p class="mt-2 flex items-center text-sm text-gray-500">
                {{ pipeline.description || 'description is missing' }}
              </p>
            </div>
            <div class="mt-4 md:mt-0">
              <ul class="flex flex-wrap -m-1">
                <li v-for="pipelineStage in pipelineStages" :key="pipelineStage.id" class="p-1">
                  <span
                    class="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium"
                    :class="[pipelineStage.color ? 'text-white' : 'bg-gray-100 text-gray-800']"
                    :style="{ backgroundColor: pipelineStage.color }"
                  >
                    {{ pipelineStage.name }}
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div>
          <svg
            class="h-5 w-5 text-gray-400"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fill-rule="evenodd"
              d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1
                      0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
              clip-rule="evenodd"
            />
          </svg>
        </div>
      </div>
    </RouterLink>
  </li>
</template>

<script>
const props = {
  pipeline: {
    type: Object,
    required: true,
  },
};

const computed = {
  pipelineStages() {
    const { pipelineStages: pipelineStageIds = [] } = this.pipeline;
    const {
      state: { entities },
    } = this.$store;

    return pipelineStageIds.map((id) => entities.pipelineStages.byId[id]).filter((p) => p);
  },
};

export default {
  props,
  computed,
};
</script>
